import { JoinButton } from 'app/src/shared/components'
import { useTranslation } from 'react-i18next'

export function HomeHeaderSection() {
  const { t } = useTranslation('landing', { keyPrefix: 'Landing.HomeHeader' })
  return (
    <div className='grid px-[8px]'>
      <div>
        <h1 className='text-center text-3xl font-bold'>{t('Title')}</h1>
      </div>
      <div>
        <p className='welfareportal-typographybody'>{t('Text')}</p>
      </div>
      <div className='mx-auto'>
        <JoinButton className='mb-5 mt-2' />
      </div>
    </div>
  )
}
